import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 获取小程序基本信息
export function getsmallappinfo(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(APINames.Native.GET_SMALL_APP_INFO, option);
}
